const LOGO_URL = "/community-iq-logo.png";

export default function CommunityIQLogo({
  className = "w-14 h-auto",
  alt = "CommunityIQ — Smarter HOA management. Stronger communities.",
}) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={`${className} object-contain select-none`}
      draggable="false"
      data-testid="communityiq-logo"
    />
  );
}
